module.exports = __webpack_public_path__ + "img/nav-icon-led-flash-alerts_2x.6fdd3777.svg";